import { useEffect, useContext } from 'react';
import BillingPageContent from '../../components/client/subscription/BillingPageContent';
import StripeElementsProvider from '../../components/client/subscription/StripeElementsProvider';
import { MeContext } from '../../context/MeContext';
import { useBilling } from '../../store/client/BillingContext';
import { useNavigate } from 'react-router-dom';
import { useGetMeQuery } from '../../store/redux/api/accountApi';

const BillingPage = () => {
  const { subscription, isLoading: isBillingLoading } = useBilling();
  const meCtx = useContext(MeContext);
  const { cardlessTrialStartedAt } = meCtx.state;
  const { data: me } = useGetMeQuery();
  const entitlementsActive = Boolean(me?.entitlements_active);

  const navigate = useNavigate();

  useEffect(() => {
    if (isBillingLoading) return;
    if (!cardlessTrialStartedAt && !subscription && !entitlementsActive) {
      navigate('/dashboard');
    }
  }, [
    cardlessTrialStartedAt,
    subscription,
    isBillingLoading,
    entitlementsActive,
    navigate,
  ]);

  return (
    <StripeElementsProvider>
      <BillingPageContent />
    </StripeElementsProvider>
  );
};

export default BillingPage;
